import React from "react";
import { useSettings } from "hooks/useStore";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel } from "swiper/modules";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import RecentlyViewedItem from "./item";
import clsx from "clsx/lite";

const RecentlyViewed = ({ productId, data, className }) => {
	const { recentlyViewed } = useSettings(["recentlyViewed"]);
	const filteredRecentlyViewed = recentlyViewed.filter((product) => +product.id !== +productId);

	if (filteredRecentlyViewed.length === 0) return null;

	const swiperSettings = {
		modules: [Navigation, Mousewheel],
		slidesPerView: 1,
		slidesPerGroup: 1,
		speed: 800,
		spaceBetween: 16,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		navigation: {
			enabled: true,
			nextEl: ".right-arrow-an",
			prevEl: ".left-arrow-an",
			disabledClass: "opacity-0",
		},
		breakpoints: {
			480: {
				slidesPerView: 2,
				slidesPerGroup: 2,
			},
			768: {
				slidesPerView: 3,
				slidesPerGroup: 3,
			},
			992: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			}
		}
	};

	return (
		<div
			className={clsx(
				"w-full flex flex-col items-center gap-4 md:gap-8 py-4 standard-section-width mx-auto px-6 overflow-hidden",
				className
			)}>
			{data.title && <h3 className="capitalize horizontal-padding">{data.title}</h3>}
			<div className="w-full text-center overflow-hidden">
				<Swiper {...swiperSettings} className="flex gap-4">
					{filteredRecentlyViewed.map((product) => (
						<SwiperSlide key={product.id} className="pb-2 md:pb-0">
							<RecentlyViewedItem product={product} />
						</SwiperSlide>
					))}
					<div className="left-arrow-an size-10 bg-white rounded-full ml-2 !top-1/3">
						<Arrow className="invert rotate-180 scale-150 filter-none" />
					</div>
					<div className="right-arrow-an size-10 bg-white rounded-full mr-2 !top-1/3">
						<Arrow className="invert scale-150 filter-none" />
					</div>
				</Swiper>
			</div>
		</div>
	);
};

export default RecentlyViewed;